var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "japanese-hiragana-story" }, [
    _vm.activeIndex === 0
      ? _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "bubble" }, [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hiragana_1_title")),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hiragana_1_text")),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "272",
                height: "257",
                viewBox: "0 0 272 257",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("circle", {
                attrs: { cx: "136", cy: "128.5", r: "120", fill: "#E2B4FF" },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M68 114.5C68 122.232 61.732 128.5 54 128.5C46.268 128.5 40 122.232 40 114.5C40 106.768 46.268 100.5 54 100.5C61.732 100.5 68 106.768 68 114.5Z",
                  fill: "#63E1E7",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M10 116.288C14.8 116.288 25.6 114.82 30.4 108.947C21.2 120.774 6.4 150.546 26.8 159.111C43.9561 166.313 63.516 144.961 53.582 107.882M53.582 107.882C53.4592 107.424 53.3319 106.963 53.2 106.5C53.3059 106.932 53.4335 107.395 53.582 107.882ZM53.582 107.882C55.6775 114.767 61.9319 126.695 70 128.523",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: { cx: "232", cy: "120.5", r: "20", fill: "#63E1E7" },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M232 106.666V162.999",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M206 124.5H258",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M232 124.5C240.125 138.711 247.6 146.921 258 154.5",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M232 124.5C223.875 138.711 216.4 146.921 206 154.5",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M164 114.5C164 122.232 157.732 128.5 150 128.5C142.268 128.5 136 122.232 136 114.5C136 106.768 142.268 100.5 150 100.5C157.732 100.5 164 106.768 164 114.5Z",
                  fill: "#AC6ED1",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M108 118.5L152 118.5V150.856C152 155.833 149.486 158.322 145.714 159.567C141.943 160.811 136.914 160.811 134.4 159.567",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M124 104.5V130.239C124 146.63 121.333 156.717 112 160.5",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
        ])
      : _vm.activeIndex === 1
      ? _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "bubble" }, [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hiragana_2_title")),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hiragana_2_text")),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "272",
                height: "256",
                viewBox: "0 0 272 256",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("rect", {
                attrs: {
                  x: "16",
                  y: "16",
                  width: "104",
                  height: "224",
                  rx: "16",
                  fill: "#E2B4FF",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M96 91C96 98.732 89.732 105 82 105C74.268 105 68 98.732 68 91C68 83.268 74.268 77 82 77C89.732 77 96 83.268 96 91Z",
                  fill: "#63E1E7",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M38 92.788C42.8 92.788 53.6 91.3198 58.4 85.447C49.2 97.2742 34.4 127.046 54.8 135.611C71.9561 142.813 91.516 121.461 81.582 84.3825M81.582 84.3825C81.4592 83.924 81.3319 83.4632 81.2 83C81.3059 83.4319 81.4335 83.8945 81.582 84.3825ZM81.582 84.3825C83.6775 91.2669 89.9319 103.195 98 105.023",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M31 166C32.1667 166 35.5 165.8 37.5 165C32.5 168.5 29.3224 177.581 35 179C41.1123 180.528 43.5 173 42 164.5C42.5 167 43.5 170 46 173",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M53.5 167.5C53.5 168.5 53.3 171.3 52.5 174.5C53.3333 173.333 56 171 60 171C65 171 65.2227 175.466 61 178C58.5 179.5 55 179 55 179M55 164C56.1667 164.5 59.2 165.5 62 165.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M75.5 164.5C75.3333 166.5 74.2 172.1 71 178.5M70 168.5C71.8333 168.333 75.8 168 77 168C78.5 168 80.5 168.5 80.5 171C80.5 173.5 80 177.5 78.5 178.5C77.3 179.3 75.6667 178.833 75 178.5M83 166.5C83.6667 167.333 85.2 169.7 86 172.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M84 163C84.5 163.4 85 164.2 85 165M86 162C86.5 162.4 87 163.2 87 164",
                  stroke: "#2C3143",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M96 164C95.3333 166.333 93.4 171.8 91 175",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M90.5 167C92 167.167 95.8 167.3 99 166.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M102 167C103 167.5 104.3 168.2 105.5 169",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M101 170C101 171.833 101 175.8 101 177C101 178.5 100 179.5 98 179.5C96 179.5 95 178.5 95 177C95 175 99 172.5 105 177.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  x: "152",
                  y: "16",
                  width: "104",
                  height: "224",
                  rx: "16",
                  fill: "#8EA3EE",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M232.5 91C232.5 98.732 226.232 105 218.5 105C210.768 105 204.5 98.732 204.5 91C204.5 83.268 210.768 77 218.5 77C226.232 77 232.5 83.268 232.5 91Z",
                  fill: "#E2B4FF",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M176.5 94.5L220.5 94.5V127.356C220.5 132.333 217.986 134.822 214.214 136.067C210.443 137.311 205.414 137.311 202.9 136.067",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M192.5 81V106.739C192.5 123.13 189.833 133.217 180.5 137",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M167 168H180C180 171 179.7 177.2 178.5 178C177.3 178.8 175.667 178.167 175 178M173 164C173.333 167 172.7 174.1 167.5 178.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M207 168H220C220 171 219.7 177.2 218.5 178C217.3 178.8 215.667 178.167 215 178M213 164C213.333 167 212.7 174.1 207.5 178.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M187 172C188.333 171.333 191.5 168.8 193.5 164M192 167H200.5C199 170.5 196 175.5 188 180M192.5 171.5C195 172.5 195.6 173 198 175",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M226 169H241.5M234 164.5V170.5C234 173 232.5 177 229 179",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
            ]
          ),
        ])
      : _vm.activeIndex === 2
      ? _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "bubble" }, [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hiragana_3_title")),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hiragana_3_text")),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "272",
                height: "256",
                viewBox: "0 0 272 256",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("rect", {
                attrs: {
                  x: "152",
                  y: "42",
                  width: "104",
                  height: "198",
                  rx: "52",
                  fill: "#8EA3EE",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M219.366 186.657C217.622 187.524 213.387 189.402 210.5 190M210.5 184V193C210.5 195.5 211.022 196.121 213.305 196.3C215.588 196.478 217.129 196.454 220.253 195.96",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M190.5 190H202.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M226.5 190H238.5",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M174 185C173.448 185 173 185.448 173 186C173 186.552 173.448 187 174 187V185ZM184.5 186H185.5V185H184.5V186ZM183.5 197C183.5 197.552 183.948 198 184.5 198C185.052 198 185.5 197.552 185.5 197H183.5ZM184.5 197C185.052 197 185.5 196.552 185.5 196C185.5 195.448 185.052 195 184.5 195V197ZM174 195C173.448 195 173 195.448 173 196C173 196.552 173.448 197 174 197V195ZM174 187H184.5V185H174V187ZM183.5 186V197H185.5V186H183.5ZM184.5 195H174V197H184.5V195Z",
                  fill: "#2C3143",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M204 105.5H200H183C180.791 105.5 179 107.291 179 109.5V116V122.5C179 131.889 186.611 139.5 196 139.5H204C213.389 139.5 221 131.889 221 122.5V109.5C221 107.291 219.209 105.5 217 105.5H213",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M186.1 122.5C186.1 128.023 190.577 132.5 196.1 132.5H204.1",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M221 111.5H228C230.209 111.5 232 113.291 232 115.5C232 119.366 228.866 122.5 225 122.5H221V111.5Z",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M188.5 84L189.681 85.9683C190.75 87.7501 190.469 90.0307 189 91.5C187.531 92.9693 187.25 95.2499 188.319 97.0317L189.5 99M196.7 81L197.456 82.5403C198.092 83.8357 197.914 85.3831 197 86.5C196.086 87.6169 195.908 89.1643 196.544 90.4597L197.3 92",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M223.467 136.524C224.529 135.092 224.228 133.07 222.795 132.008C217.354 127.977 207.672 132.645 202.918 139.061C198.165 145.477 196.517 156.098 201.958 160.13C203.391 161.191 205.413 160.89 206.474 159.458L223.467 136.524Z",
                  fill: "#AC6ED1",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M225.878 138.311C226.939 136.878 228.961 136.577 230.394 137.639C235.834 141.67 234.187 152.292 229.433 158.707C224.679 165.123 214.997 169.791 209.557 165.76C208.124 164.699 207.823 162.677 208.885 161.244L225.878 138.311Z",
                  fill: "#E2B4FF",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  x: "16",
                  y: "16",
                  width: "104",
                  height: "198",
                  rx: "52",
                  fill: "#E2B4FF",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M47.4476 104.688C47.854 105.191 48.2346 105.715 48.5878 106.26L55.4737 116.875C57.5276 120.042 60.7728 122.245 64.4736 122.985C65.6724 123.225 66.8891 123.332 68.1021 123.308C66.0084 129.069 60.4848 133.184 54 133.184C45.7157 133.184 39 126.469 39 118.184C39 112.25 42.4467 107.12 47.4476 104.688Z",
                  fill: "#63E1E7",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M76.2023 119.907C75.4181 120.174 74.9988 121.026 75.2658 121.81C75.5327 122.594 76.3849 123.014 77.1691 122.747L76.2023 119.907ZM84.6008 115.894L83.3709 115.035L84.6008 115.894ZM88.6857 96.3265L87.1857 96.3151L88.6857 96.3265ZM88.6857 70.3265L90.1857 70.3193L90.1797 69.0924L88.9761 68.8549L88.6857 70.3265ZM81.8302 76.0707L83.2994 76.3735L83.3014 76.3635L81.8302 76.0707ZM77.2166 91.0237C77.0493 91.8351 77.5715 92.6284 78.3829 92.7956C79.1943 92.9629 79.9876 92.4407 80.1548 91.6293L77.2166 91.0237ZM64.6858 86.3266L63.317 86.9401C63.6285 87.635 64.4111 87.9862 65.1372 87.757C65.8633 87.5279 66.3026 86.791 66.1588 86.0433L64.6858 86.3266ZM60.4978 64.5489L59.0247 64.8321V64.8321L60.4978 64.5489ZM53.3107 60.9514L51.9419 61.5649L53.3107 60.9514ZM45.6186 64.4695L44.2593 65.1037V65.1037L45.6186 64.4695ZM57.6858 90.3347L56.5197 91.2783C56.9965 91.8674 57.8378 92.0084 58.4806 91.6068C59.1233 91.2052 59.3655 90.3873 59.0451 89.7005L57.6858 90.3347ZM43.2201 72.4584L44.3861 71.5148H44.3861L43.2201 72.4584ZM36.6129 77.8226L35.4499 78.77L35.4499 78.77L36.6129 77.8226ZM51.6858 96.3266L50.805 97.5407C51.4148 97.9831 52.2581 97.9045 52.7757 97.3571C53.2933 96.8097 53.3246 95.9633 52.8488 95.3792L51.6858 96.3266ZM37.2654 85.8657L38.1462 84.6516L38.1462 84.6516L37.2654 85.8657ZM64.4735 122.984L64.7677 121.513L64.4735 122.984ZM68.3915 125.297C69.2039 125.46 69.9941 124.933 70.1566 124.121C70.319 123.308 69.7922 122.518 68.9799 122.356L68.3915 125.297ZM32.1976 92.8694L33.0755 91.6531H33.0755L32.1976 92.8694ZM43.8517 101.281L44.7296 100.065L44.7296 100.065L43.8517 101.281ZM48.5877 106.259L49.8462 105.442V105.442L48.5877 106.259ZM55.4737 116.875L54.2152 117.691L55.4737 116.875ZM68.4039 63.02L69.8763 62.7337L68.4039 63.02ZM72.3383 91.113C72.4964 91.9262 73.2838 92.4572 74.097 92.2991C74.9102 92.141 75.4413 91.3536 75.2831 90.5404L72.3383 91.113ZM31.2274 86.8279L32.442 87.7082L32.442 87.7082L31.2274 86.8279ZM37.4202 71.6859L36.5417 70.47L36.5417 70.47L37.4202 71.6859ZM47.9664 58.7213L48.493 60.1258L48.493 60.1258L47.9664 58.7213ZM63.9522 59.7933L64.1383 61.2817V61.2817L63.9522 59.7933ZM90.1857 96.3379C90.2242 91.2755 90.2242 84.7696 90.2146 79.5325C90.2098 76.9133 90.2025 74.6102 90.1965 72.9618C90.1935 72.1376 90.1908 71.4771 90.1888 71.0226C90.1879 70.7953 90.1871 70.6195 90.1865 70.5006C90.1863 70.4411 90.1861 70.3958 90.1859 70.3653C90.1858 70.3501 90.1858 70.3386 90.1857 70.3309C90.1857 70.3271 90.1857 70.3241 90.1857 70.3222C90.1857 70.3212 90.1857 70.3205 90.1857 70.32C90.1857 70.3198 90.1857 70.3196 90.1857 70.3194C90.1857 70.3193 90.1857 70.3193 88.6857 70.3265C87.1857 70.3338 87.1857 70.3338 87.1857 70.334C87.1857 70.3341 87.1857 70.3343 87.1857 70.3345C87.1857 70.335 87.1857 70.3357 87.1857 70.3366C87.1857 70.3386 87.1858 70.3414 87.1858 70.3452C87.1858 70.3529 87.1859 70.3643 87.1859 70.3795C87.1861 70.4098 87.1863 70.455 87.1866 70.5143C87.1871 70.633 87.1879 70.8085 87.1889 71.0355C87.1908 71.4894 87.1935 72.1493 87.1965 72.9728C87.2025 74.6197 87.2098 76.921 87.2146 79.538C87.2242 84.7734 87.2242 91.2675 87.1857 96.3151L90.1857 96.3379ZM88.9761 68.8549C84.5861 67.9886 81.1917 71.5945 80.3591 75.7779L83.3014 76.3635C83.955 73.0792 86.2688 71.3785 88.3953 71.7981L88.9761 68.8549ZM80.3611 75.7679L77.2166 91.0237L80.1548 91.6293L83.2994 76.3735L80.3611 75.7679ZM85.8306 116.753C89.7338 111.163 90.1218 104.727 90.1857 96.3379L87.1857 96.3151C87.1213 104.779 86.6755 110.303 83.3709 115.035L85.8306 116.753ZM76.6857 121.327C77.1691 122.747 77.1694 122.746 77.1698 122.746C77.17 122.746 77.1703 122.746 77.1706 122.746C77.1712 122.746 77.1719 122.746 77.1726 122.745C77.1741 122.745 77.176 122.744 77.1781 122.743C77.1824 122.742 77.1881 122.74 77.195 122.738C77.2088 122.733 77.2277 122.726 77.2514 122.718C77.2989 122.701 77.3659 122.676 77.4502 122.645C77.6187 122.581 77.8572 122.489 78.1491 122.366C78.7317 122.122 79.5341 121.758 80.4215 121.274C82.1617 120.324 84.3798 118.831 85.8306 116.753L83.3709 115.035C82.3136 116.55 80.5743 117.773 78.984 118.641C78.2061 119.065 77.5 119.386 76.9904 119.599C76.7362 119.706 76.5327 119.785 76.3958 119.836C76.3273 119.862 76.2756 119.881 76.2427 119.892C76.2262 119.898 76.2145 119.902 76.2077 119.905C76.2043 119.906 76.2021 119.907 76.2012 119.907C76.2007 119.907 76.2006 119.907 76.2008 119.907C76.2009 119.907 76.2011 119.907 76.2013 119.907C76.2015 119.907 76.2017 119.907 76.2018 119.907C76.2021 119.907 76.2023 119.907 76.6857 121.327ZM66.1588 86.0433L61.9708 64.2656L59.0247 64.8321L63.2128 86.6098L66.1588 86.0433ZM66.0545 85.713L54.6794 60.3378L51.9419 61.5649L63.317 86.9401L66.0545 85.713ZM44.2593 65.1037L56.3264 90.9689L59.0451 89.7005L46.978 63.8353L44.2593 65.1037ZM58.8518 89.3911L44.3861 71.5148L42.054 73.4019L56.5197 91.2783L58.8518 89.3911ZM35.4499 78.77L50.5228 97.2739L52.8488 95.3792L37.7759 76.8753L35.4499 78.77ZM52.5666 95.1124L38.1462 84.6516L36.3846 87.0799L50.805 97.5407L52.5666 95.1124ZM64.1793 124.455L68.3915 125.297L68.9799 122.356L64.7677 121.513L64.1793 124.455ZM31.3197 94.0857L42.9739 102.497L44.7296 100.065L33.0755 91.6531L31.3197 94.0857ZM47.3293 107.075L54.2152 117.691L56.7321 116.058L49.8462 105.442L47.3293 107.075ZM64.7677 121.513C61.4634 120.852 58.5659 118.885 56.7321 116.058L54.2152 117.691C56.4891 121.196 60.082 123.635 64.1793 124.455L64.7677 121.513ZM30.0129 85.9476C28.1232 88.555 28.7087 92.2011 31.3197 94.0857L33.0755 91.6531C31.8097 90.7396 31.5259 88.9721 32.442 87.7082L30.0129 85.9476ZM38.1462 84.6516C35.5425 82.7628 31.9006 83.3431 30.0129 85.9476L32.442 87.7082C33.357 86.4457 35.1225 86.1643 36.3846 87.0799L38.1462 84.6516ZM37.7759 76.8753C36.7753 75.6469 37.0143 73.8296 38.2986 72.9018L36.5417 70.47C33.8591 72.4082 33.3598 76.204 35.4499 78.77L37.7759 76.8753ZM46.978 63.8353C46.3053 62.3936 47.0034 60.6845 48.493 60.1258L47.4397 57.3169C44.3127 58.4895 42.8473 62.0773 44.2593 65.1037L46.978 63.8353ZM54.6794 60.3378C53.4421 57.5775 50.272 56.2547 47.4397 57.3169L48.493 60.1258C49.8423 59.6199 51.3525 60.25 51.9419 61.5649L54.6794 60.3378ZM42.9739 102.497C44.6964 103.741 46.1732 105.293 47.3293 107.075L49.8462 105.442C48.4881 103.349 46.7532 101.525 44.7296 100.065L42.9739 102.497ZM64.1383 61.2817C65.4569 61.1169 66.6778 62.0019 66.9314 63.3063L69.8763 62.7337C69.3214 59.8802 66.6507 57.9444 63.7662 58.3049L64.1383 61.2817ZM44.3861 71.5148C42.4635 69.1389 39.0191 68.6802 36.5417 70.47L38.2986 72.9018C39.4846 72.0449 41.1336 72.2645 42.054 73.4019L44.3861 71.5148ZM61.9708 64.2656C61.695 62.8314 62.6891 61.4629 64.1383 61.2817L63.7662 58.3049C60.5961 58.7011 58.4214 61.6949 59.0247 64.8321L61.9708 64.2656ZM66.9314 63.3063L72.3383 91.113L75.2831 90.5404L69.8763 62.7337L66.9314 63.3063Z",
                  fill: "#2C3143",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M73.9133 122.525C73.2353 121.01 73.9138 119.232 75.4287 118.554C76.9436 117.876 78.7213 118.554 79.3992 120.069C80.0772 121.584 79.3988 123.362 77.8839 124.04C76.369 124.718 74.5913 124.039 73.9133 122.525Z",
                  fill: "#2C3143",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M82.1858 57.3272C85.6858 56.8272 94.1858 56.5272 100.186 59.3272M93.8536 65.7455C96.2245 65.6588 101.869 66.2259 105.477 69.1871",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M80.7144 150C80.4457 152.204 79.422 157.547 78.261 159.568C78.8881 158.475 81.3153 155.789 85.1217 156.342C89.4089 156.965 89.5144 161.185 86.6308 162.486C84.5246 163.437 82.918 163.329 80.3919 163.114M76.6082 152.288C78.132 152.487 82.4388 152.633 87.4747 151.62",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M95.5931 150.345C94.9686 153.715 94.0448 161.07 95.3456 163.531C95.4163 162.576 95.8122 160.222 96.8303 158.44M99.6228 153.385C101.213 153.645 105.074 153.951 107.788 153.103M104.607 150.027C104.64 152.338 104.729 157.278 104.834 159.607M104.834 159.607C104.841 159.76 104.847 159.902 104.854 160.031C104.996 162.647 103.617 163.248 102.062 163.212C100.507 163.177 98.8069 161.898 99.6935 160.243C100.354 159.01 102.674 158.929 104.834 159.607ZM104.834 159.607C106.142 160.018 107.391 160.706 108.177 161.586",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M25 151.232C27.6625 151.562 30.2 151.632 33 151.232M23.978 158.735C23.6383 159.702 23.4064 161.827 25.1965 162.589C27.4341 163.542 30.6687 163.298 34.2577 162.745",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M64.9607 151.924C65.9599 152.01 68.5683 152.13 71.0078 151.924M64.1627 158.963C63.8994 159.781 63.8612 161.484 65.2182 162.207C66.7392 163.017 68.9869 162.414 71.4822 162.207M59.8014 150.449C59.0403 153.05 57.9176 159.297 59.5159 163.483C59.5635 162.674 59.9251 160.562 60.9906 158.584",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M46.74 150.268C45.3586 152.531 41.8904 158.876 40.1729 163.549C40.8885 161.286 43.7178 156.17 46.5651 156.287C49.4123 156.405 46.2995 161.859 49.2176 163.049C51.6092 164.025 53.6562 160.258 54.3053 159.027",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M113 159.232V152.232",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-miterlimit": "10",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: {
                  cx: "112.972",
                  cy: "162.204",
                  r: "0.972046",
                  fill: "#2C3143",
                },
              }),
            ]
          ),
        ])
      : _vm.activeIndex === 3
      ? _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "bubble" }, [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hiragana_4_title")),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hiragana_4_text")),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "272",
                height: "256",
                viewBox: "0 0 272 256",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M126.103 37.1063C127.382 42.7171 123.871 48.3023 118.262 49.5813C104.072 52.8168 91.0288 59.8508 80.5273 69.9305C80.1405 70.3017 79.7577 70.6765 79.379 71.0549C83.4497 67.0213 90.0185 67.0332 94.0745 71.0905C98.1424 75.1596 98.1424 81.7571 94.0745 85.8263C86.7236 93.1795 81.4293 102.333 78.7201 112.372C78.2121 114.255 77.7983 116.156 77.4788 118.069C77.576 117.487 77.6821 116.906 77.7969 116.325C78.9136 110.68 84.3939 107.009 90.0374 108.127C95.6808 109.244 99.3504 114.726 98.2337 120.371C97.0013 126.6 97.3238 133.037 99.1726 139.112C101.021 145.187 104.339 150.712 108.833 155.198C113.326 159.684 118.856 162.992 124.933 164.83C131.009 166.667 137.445 166.977 143.67 165.732C149.895 164.487 155.717 161.725 160.62 157.692C165.524 153.659 169.357 148.478 171.78 142.609C174.204 136.74 175.143 130.363 174.515 124.044C173.886 117.725 171.71 111.659 168.178 106.382C164.977 101.6 166.257 95.1285 171.037 91.9267C175.817 88.7249 182.287 90.0056 185.488 94.7873C189.291 100.469 192.074 106.745 193.734 113.333C192.328 107.753 195.71 102.089 201.288 100.682C206.867 99.275 212.529 102.658 213.935 108.238C216.634 118.947 217.088 130.065 215.306 140.899C216.248 135.229 221.603 131.392 227.275 132.326C232.951 133.261 236.795 138.622 235.86 144.301C232.881 162.394 225.041 179.337 213.177 193.316C201.314 207.295 185.874 217.785 168.51 223.663C151.146 229.541 132.511 230.586 114.599 226.686C96.6874 222.786 80.1725 214.088 66.8216 201.523C53.4708 188.957 43.7864 172.997 38.8048 155.35C33.8232 137.703 33.7317 119.033 38.5402 101.339C43.3487 83.6436 52.8762 67.5893 66.1033 54.8935C79.3305 42.1978 95.7594 33.3382 113.632 29.2629C119.241 27.9839 124.825 31.4955 126.103 37.1063Z",
                  fill: "#E2B4FF",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M148 109.5C149.667 112 153.5 118.5 155.5 124.5M130 104C129.333 110.833 126.2 127.5 119 139.5M117 115.5C120.333 115 127.613 113.837 132 113.5C138.5 113 142 114.5 142 119.5C142 124.5 141.5 137 137 139C134.5 140.111 131.5 139.5 129.5 139",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M202.116 121.143C204.076 121.388 209.023 121.657 213.137 120.776M209.096 116C209.341 119.306 209.537 126.653 208.361 129.592C207.186 132.531 205.423 133.755 204.688 134M196.974 116.367C196.239 119.918 195.21 128.931 196.974 133.633C196.851 132.653 197.047 129.298 198.81 126.653",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M136.928 49L128.827 55.6009C127.769 56.4631 127.718 58.0621 128.72 58.9894L136.928 66.5897",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M124.717 186C127.087 186.148 133.16 186.355 138.493 186M140.27 203.33C136.419 203.923 127.739 204.663 125.606 202.886C123.473 201.108 123.977 198.442 124.273 197.109",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M66.3523 116C67.1116 119.417 69.1617 126.706 71.2878 128.528C70.4019 128.402 68.2506 128.149 66.732 128.149M58.3797 118.658C60.7841 118.911 66.8838 119.113 72.0471 117.898M58 123.593C60.6576 123.846 67.4153 124.049 73.186 122.834M70.5285 134.223C67.9975 134.729 62.328 135.21 59.8983 133.084C58.3797 131.756 58.7593 129.288 59.5186 128.149",
                  stroke: "#2C3143",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "bevel",
                },
              }),
            ]
          ),
        ])
      : _vm.activeIndex === 4
      ? _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "bubble" }, [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hiragana_5_title")),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hiragana_5_text")),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "272",
                height: "256",
                viewBox: "0 0 272 256",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M33.3821 121.027H19V137.285V164.799H40.8859L69.0248 192V163.09L55.268 149.792H33.3821V122.278V121.027Z",
                  fill: "#E2B4FF",
                },
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: { cx: "33.5", cy: "124.5", r: "4.5", fill: "#2C3143" },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M33.5 105.5V104H32V105.5H33.5ZM33.5 148C32.6716 148 32 148.672 32 149.5C32 150.328 32.6716 151 33.5 151V148ZM83.5 176.5L82.4684 177.589C82.9035 178.001 83.5421 178.115 84.0927 177.878C84.6432 177.641 85 177.099 85 176.5H83.5ZM83.5 78.5H85C85 77.8983 84.6404 77.3548 84.0866 77.1195C83.5328 76.8841 82.8919 77.0025 82.4588 77.4202L83.5 78.5ZM55.5 105.5V107C55.8884 107 56.2616 106.849 56.5412 106.58L55.5 105.5ZM55 149.5L56.0316 148.411C55.753 148.147 55.3838 148 55 148V149.5ZM32 122.5C32 123.328 32.6716 124 33.5 124C34.3284 124 35 123.328 35 122.5H32ZM82.4588 77.4202L54.4588 104.42L56.5412 106.58L84.5412 79.5798L82.4588 77.4202ZM55.5 104H33.5V107H55.5V104ZM53.9684 150.589L82.4684 177.589L84.5316 175.411L56.0316 148.411L53.9684 150.589ZM32 105.5V122.5H35V105.5H32ZM33.5 151H55V148H33.5V151ZM85 176.5V78.5H82V176.5H85Z",
                  fill: "#2C3143",
                },
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: {
                  cx: "189.084",
                  cy: "138.537",
                  r: "22.5112",
                  fill: "#E2B4FF",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M103.886 111.334C107.335 115.987 109.357 121.645 109.357 127.748C109.357 133.851 107.335 139.51 103.886 144.163",
                  stroke: "#AC6ED1",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M120.3 94.9199C127.138 103.85 131.243 115.284 131.243 127.749C131.243 140.213 127.138 151.648 120.3 160.577",
                  stroke: "#AC6ED1",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M184.436 106.589C189.752 107.953 203.574 109.318 216.332 103.861M199.055 99.7676C195.068 109.318 193.739 122.415 199.055 142.061M207.029 144.79C210.13 144.79 217.129 142.88 220.319 135.24C223.738 127.049 220.315 119.862 210.05 117.982M210.05 117.982C208.346 117.67 206.453 117.504 204.371 117.504C189.752 117.504 181.147 129.917 183.108 137.968C185.329 147.09 202.705 140.032 210.05 117.982ZM210.05 117.982C210.395 116.946 210.718 115.877 211.016 114.775",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M216.598 85.8545L224.201 66",
                  stroke: "#AC6ED1",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M230.115 89.0224L248.093 71.8016",
                  stroke: "#AC6ED1",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M237.272 101.806L252.479 93.5682",
                  stroke: "#AC6ED1",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
        ])
      : _vm.activeIndex === 5
      ? _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "bubble" }, [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hiragana_6_title")),
              },
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(this.$i18n("stories_hiragana_6_text")),
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "272",
                height: "257",
                viewBox: "0 0 272 257",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M136 108L90 188H203.099C211.893 188 217.7 178.853 213.959 170.895L194.5 129.5L185 120.5L175.5 129.5L154 109L144 118L136 108Z",
                  fill: "#8EA3EE",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M246.5 188L215.5 126M198.5 92L188.317 71.6334C186.284 67.568 182.129 65 177.584 65H167.453C163.153 65 159.181 67.3015 157.042 71.0327L152.189 79.5M30 188H90L147.03 88.5",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: { cx: "29.5", cy: "188", r: "3.5", fill: "#2C3143" },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M136 108.5L144 118.5L154 108.5L175.5 130L185 120.5L194.5 130L200.187 124.313",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M123 130.374C122.21 130.131 121.37 130 120.5 130H89.5C84.8056 130 81 133.806 81 138.5C81 143.194 84.8056 147 89.5 147H113.5",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  x: "181",
                  y: "92",
                  width: "48",
                  height: "17",
                  rx: "8.5",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
              _vm._v(" "),
              _c("rect", {
                attrs: {
                  x: "197",
                  y: "109",
                  width: "48",
                  height: "17",
                  rx: "8.5",
                  stroke: "#2C3143",
                  "stroke-width": "3",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "actions" },
            [
              _c("v-button", {
                attrs: {
                  i18n: { id: "onboarding_experience_start_btn" },
                  filled: true,
                  color: "primary",
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.startLearning.apply(null, arguments)
                  },
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }